import * as Yup from 'yup';

import { UserStatusEnum, UserTypeEnum } from '@api/enums';
import { useMutation } from '@tanstack/react-query';
import { addUser } from '@api/services/user.service';
import { IUser } from '@api/models/user.model';

const useUserAddForm = () => {
    const addUserMutation = useMutation((payload: IUser) => addUser(payload));
    const schema = Yup.object({
        name: Yup.string().trim(),

        company: Yup.object().shape({
            name: Yup.string().test('validate-company-name', function (name: string) {
                const { type } = this.options.context;

                if (type === UserTypeEnum.BROKER && !Boolean(name?.trim()))
                    return this.createError({ message: 'This field is required' });

                return true;
            }),
            address: Yup.string().test('validate-company-address', function (address: string) {
                const { type } = this.options.context;

                if (type === UserTypeEnum.BROKER && !Boolean(address?.trim()))
                    return this.createError({ message: 'This field is required' });

                return true;
            }),
        }),

        phoneNumber: Yup.number(),
        dp: Yup.mixed().nullable(),
        emailHeaderLogo: Yup.mixed().nullable(),
        type: Yup.string().required('This field is required'),
        status: Yup.string().required('This field is required'),
    });
    const initialValues: any = {
        name: '',
        company: {
            name: '',
            address: '',
        },
        phoneNumber: '',
        whatsappNumber: '',
        dp: '',
        dpUrl: '',
        type: UserTypeEnum.LISTER,
        status: UserStatusEnum.ENABLED,
        // file: '',
    };

    const submit = async (values: any) => {
        // console.log('values', values);
        // const formData = new FormData();
        // formData.append('name', values.name);
        // formData.append('phoneNumber', values.phoneNumber);
        // formData.append('whatsappNumber', values.whatsappNumber);
        // formData.append('role', values.roles);
        // formData.append('status', values.status);
        // formData.append('company[name]', values.company.name);
        // formData.append('company[address]', values.company.address);
        // if (values.file) {
        //     formData.append('file', values.file);
        // }
        const { data } = await addUserMutation.mutateAsync(values);
        return data;
    };
    return {
        initialValues,
        schema,
        submit,
        isSubmitting: addUserMutation.isLoading,
    };
};

export default useUserAddForm;
